// @ts-nocheck
import React, { useEffect, useMemo, useState, useRef } from "react";
import type { BounceProps } from "../types/spring-types";
import { useInputContext } from "leva/plugin";
import { useNotifications } from "../context/NotificationProvider";
import { StyledReturnButton } from "../styles/StyledReturnButton";
import { useGlobalState } from "../hooks/useGlobalState";
import { applyTool } from "../utilities/layers";
import { ToolApplyRequest } from "../types/general-types";
import * as constants from "../assets/constants";
import {
	defaultElasticDecayY,
	defaultElasticDecayX,
	defaultElasticElasticity,
	defaultElasticGravity,
	defaultElasticHang,
	defaultElasticVelocity,
	defaultDecayX,
	defaultDecayY,
} from "../assets/constants";
import { ElasticCanvas } from "./ElasticCanvas";
import HorizontalScroll from "./HorizontalScroll";

import HoverModalButton from "./HoverModalButton";
import InputSlider from "./InputSlider";
import TopSection from "./TopSection";
import { HandlesModalButton } from "./HandlesModalButton";
import { DividerX } from "../styles/DividerX";

export function Elastic() {
	const { value, label, displayValue, onUpdate, onChange, settings } =
		useInputContext<BounceProps>();
	// console.log(`value: ${JSON.stringify(value)})`)
	const { dispatch, UIStatus, configSettings } = useGlobalState();
	const [gravitySliderValue, setGravitySliderValue] = useState(
		defaultElasticGravity
	);
	const [decayYSliderValue, setDecayYValue] = useState(defaultElasticDecayY);
	const [decayXSliderValue, setDecayXValue] = useState(defaultElasticDecayX);
	const [hangSliderValue, setHangSliderValue] = useState(defaultElasticHang);
	const [velocitySliderValue, setVelocitySliderValue] = useState(
		defaultElasticVelocity
	);
	const [bounceValues, setBounceValues] = useState<CubicBounceLerp[]>([]);

	async function applyElasticHandler(value) {
		let req: ToolApplyRequest = {
			tool: "elastic",
			values: bounceValues,
			userVars: [],
			config: configSettings,
		};
		const json = await applyTool(req);
		if (json) {
			console.log(json);
			const res = JSON.parse(json);
			if (!res.success) {
				addNotification({
					message: res.message,
					type: "error",
					title: "Error",
				});
				return;
			}
			addNotification({ message: "", type: "success", title: "Success" });
		}
	}

	function handleGravitySliderChange(e: React.ChangeEvent<HTMLInputElement>) {
		setGravitySliderValue(parseInt(e.target.value));
		onUpdate({ gravity: e.target.value });
	}
	function handleDecayXChange(e: React.ChangeEvent<HTMLInputElement>) {
		setDecayXValue(parseInt(e.target.value));
		onUpdate({ decayX: e.target.value });
	}
	function handleDecayYChange(e: React.ChangeEvent<HTMLInputElement>) {
		setDecayYValue(parseInt(e.target.value));
		onUpdate({ decayY: e.target.value });
	}
	function handleHangSliderChange(e: React.ChangeEvent<HTMLInputElement>) {
		setHangSliderValue(parseInt(e.target.value));
		onUpdate({ hang: e.target.value});
	}
	function handleVelocitySliderChange(e: React.ChangeEvent<HTMLInputElement>) {
		setVelocitySliderValue(parseInt(e.target.value));
		onUpdate({ velocity: e.target.value });
	}

	function requestToolSwitch(tool) {
		if (UIStatus.currentDisplay === tool) {
			dispatch({
				type: "UIStatusUpdate",
				payload: {
					id: Date.now(),
					currentDisplay: "bezier",
					initializationTime: Date.now(),
				},
			});
		} else {
			dispatch({
				type: "UIStatusUpdate",
				payload: {
					id: Date.now(),
					currentDisplay: tool,
					initializationTime: Date.now(),
				},
			});
		}
	}

	function handleOpenPresets(e: any): void {
		dispatch({
			type: "UIStatusUpdate",
			payload: {
				id: Date.now(),
				currentDisplay: "presets",
				initializationTime: Date.now(),
			},
		});
	}
	return (
		<>
			<TopSection />
			<ElasticCanvas setBounceValues={setBounceValues} />
			<div className="flex flex-col w-full items-center gap-0">
				<div className="relative flex items-center w-full h-10 px-1.5 py-1">
					<HorizontalScroll>
						<div className="flex h-full">
							<HandlesModalButton
								type={"Out"}
								displayValue={{ x1: 0.5, x2: 0.5, y1: 0.5, y2: 0.5 }}
								onUpdate={onUpdate}
								disabled={true}
							/>
							<HandlesModalButton
								type={"In"}
								displayValue={{ x1: 0.5, x2: 0.5, y1: 0.5, y2: 0.5 }}
								onUpdate={onUpdate}
								disabled={true}
							/>
						</div>
						<DividerX />
						<div className="flex h-full">
							<HoverModalButton
								onClick={() => requestToolSwitch("elastic")}
								label={"Elastic"}
								staticOn={true}
								modalAlign="center_left"
							>
								<InputSlider
									label={"Amplitude"}
									min={constants.defaultElasticVelocityMin}
									max={constants.defaultElasticVelocityMax}
									step={1}
									value={velocitySliderValue}
									onChange={handleVelocitySliderChange}
								/>
								<InputSlider
									label={"Duration"}
									min={constants.defaultElasticGravityMin}
									max={constants.defaultElasticGravityMax}
									step={1}
									value={gravitySliderValue}
									onChange={handleGravitySliderChange}
								/>
								<InputSlider
									label={"Decay X"}
									min={constants.defaultElasticDecayMinX}
									max={constants.defaultElasticDecayMaxX}
									step={1}
									value={decayXSliderValue}
									onChange={handleDecayXChange}
								/>
								<InputSlider
									label={"Decay Y"}
									min={constants.defaultElasticDecayMinY}
									max={constants.defaultElasticDecayMaxY}
									step={1}
									value={decayYSliderValue}
									onChange={handleDecayYChange}
								/>
								<InputSlider
									label={"Hang"}
									min={constants.defaultElasticHangMin}
									max={constants.defaultElasticHangMax}
									step={1}
									value={hangSliderValue}
									onChange={handleHangSliderChange}
								/>
							</HoverModalButton>
						</div>
					</HorizontalScroll>
					<StyledReturnButton
						onClick={() => applyElasticHandler(value)}
						onChange={onChange}
					/>
				</div>
			</div>
		</>
	);
}